import config from '../../config';
import Swipe from '../../utils/Swipe';
// import Debug from '../../utils/Debug';
import LevelManager from './LevelManager/';
import Player from './Player';
import Bile from './Bile';

const TILE_SIZE = config.TILE_SIZE;
const TILE_SIZE_HALF = TILE_SIZE / 2;

let FPS;

let soundManager;
let dataManager;

class Play extends Phaser.Scene {
  init (data) {
    // console.log('Play.init', data);
    let g = this;
    dataManager = g.sys.game.dataManager;
    soundManager = g.scene.get('SoundManager');

    FPS = 1000 / g.sys.game.loop.targetFps;
    // console.log('Play');
    dataManager.setSessionItem(config.BASE_SCENE, 'Play');

    g.isContinue = !!data.isContinue;
    g.queuedPause = !!data.queuedPause;
    g.queuedPowerUp = data.queuedPowerUp;

    // g.showStore = !g.isContinue;
    g.getLastBg = g.isContinue;

    g.activePowerUp = false;
    g.coolDownActive = false;
  }

  create () {
    let g = this;

    // g.bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'bg-blue');

    g.bgDark = g.add.sprite(config.CENTER_X - 1, -1800, 'bg-black');
    g.bgDark2 = g.add.sprite(config.CENTER_X - 1, 0, 'bg-black');
    g.bgDark3 = g.add.sprite(config.CENTER_X - 1, 1800, 'bg-black');
    var bgColor = g.getBgColor();
    g.bg = g.add.sprite(config.CENTER_X - 1, -1800, bgColor);
    g.bg2 = g.add.sprite(config.CENTER_X - 1, 0, bgColor);
    g.bg3 = g.add.sprite(config.CENTER_X - 1, 1800, bgColor);
    // on setCamera

    if (g.isContinue) {
      let checkPointScore = dataManager.getSessionItem('checkPointScore');
      dataManager.setScore(checkPointScore);
      g.scoreValue = checkPointScore;
    } else {
      dataManager.setSessionItem('lastMapIndex', 0);
      dataManager.setSessionItem('checkPointScore', 0);
      dataManager.setScore(0);
      g.scoreValue = 0;
    }

    g.levelManager = new LevelManager(g);

    g.player = new Player(g);

    g.bile = new Bile(g);

    g.fg = [];

    let tubes = g.add.sprite(config.CENTER_X, -10, 'tubes');
    tubes.setOrigin(0.5, 0);
    tubes.setScrollFactor(0);
    g.fg.push(tubes);
    
    let score = g.add.text(config.CENTER_X, 130, g.game.localisationManager.language != "ar" ? g.scoreValue.toLocaleString(g.game.localisationManager.language) : g.scoreValue, { fontFamily: "FredBurger Black", fontSize: (86) +"px", color: "#ffef00", align: 'center' })
    score.setStroke('#000', 12);
    score.setOrigin(0.5);
    score.setScrollFactor(0);
    g.fg.push(score);

    if (dataManager.getHighScore() !== 0) {
      
      let highScore = g.add.text(config.CENTER_X, score.y + 66, g.game.localisationManager.language != "ar" ? dataManager.getHighScore().toLocaleString(g.game.localisationManager.language) : dataManager.getHighScore(), { fontFamily: "FredBurger Black", fontSize: (36) +"px", color: "#FFF", align: 'center' })
      highScore.setOrigin(0.5);
      highScore.setScrollFactor(0);
      g.fg.push(highScore);
    }

    let settingsBtn = g.add.sprite(config.WIDTH - 80, 80, 'settings-sprite');
    settingsBtn.setFrame('btn-pause.png');
    settingsBtn.setScrollFactor(0);
    settingsBtn.setInteractive();
    settingsBtn.on('pointerdown', () => {
      g.scene.launch('Settings');
    });
    g.fg.push(settingsBtn);

    let swipeEvents = {
      up: () => {
        g.player.move(config.UP);
      },
      down: () => {
        g.player.move(config.DOWN);
      },
      left: () => {
        g.player.move(config.LEFT);
      },
      right: () => {
        g.player.move(config.RIGHT);
      }
    };
    g.swipe = new Swipe(g, swipeEvents);
    g.sprites = { score };

    soundManager.playMusic('loop-' + g.levelManager.getDifficulty());

    g.events.off('resume');
    g.events.on('resume', () => {
      // console.log('On Play Resume!!!');
      soundManager.resumeMusic();
    });

    if (g.queuedPause) {
      g.queuedPause = false;
      g.scene.launch('Settings');
    }

    // temp
    // g.time.delayedCall(500, () => {
    //   g.scene.launch('Continue');
    //   // g.scene.launch('Settings');
    //   // g.scene.launch('Store');
    //   // console.log(g.cameras.main.scrollY);
    // });
    // end temp

    if (g.queuedPowerUp) {
      switch (g.queuedPowerUp) {
        case config.ARMOR:
          g.activateArmor();
          break;
        case config.MAGNET:
          g.activateMagnet();
          break;
        case config.BOOSTER:
          g.activateScoreBooster();
          break;
        case config.ANTACID:
          g.activateAntacid();
          break;
      }
      g.queuedPowerUp = false;
    }

    g.time.delayedCall(750, () => {
      if (!g.activePowerUp) {
        g.bile.start();
      }
    });

    g.isContinue = false;
    
  }

  activateScoreBooster () {
    let g = this;
    soundManager.playSound('powerup-enabled');
    g.activePowerUp = config.BOOSTER;
    let powerIcon = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'powerup-icons');
    powerIcon.setScale(0);
    powerIcon.setScrollFactor(0);
    powerIcon.setFrame('Booster.png');
    let scoreBooster = g.add.sprite(config.CENTER_X, 130, 'booster-effect');
    scoreBooster.play('booster-effect');
    scoreBooster.setScrollFactor(0);
    scoreBooster.setAlpha(0);
    let x2Bounce = g.add.sprite(config.CENTER_X - g.sprites.score.width / 2 - 25, 150, 'x2-bounce');
    x2Bounce.setScrollFactor(0);
    x2Bounce.setAlpha(0);
    x2Bounce.play('x2-bounce');
    g.fg.push(scoreBooster);
    g.fg.push(x2Bounce);
    g.fg.push(powerIcon);
    let timeline = g.tweens.createTimeline();
    g.tweens.add({
      targets: [scoreBooster, x2Bounce],
      alpha: 1,
      duration: 500,
      ease: 'Quad.easeOut'
    });
    timeline.add({
      targets: powerIcon,
      scaleX: 0.5,
      scaleY: 0.5,
      duration: 500,
      ease: 'Back.easeOut'
    });
    timeline.add({
      targets: powerIcon,
      scaleX: 0,
      scaleY: 0,
      duration: 250,
      delay: 500,
      ease: 'Back.easeIn',
      onComplete: () => {
        g.bile.start();
        g.scoreBoosterActive = true;
      }
    });
    timeline.add({
      targets: [scoreBooster, x2Bounce],
      delay: config.POWER_UP_DURATION,
      alpha: 0,
      repeat: 10,
      duration: 100,
      repeatDelay: 100,
      onComplete: () => {
        g.startCoolDown();
        timeline.destroy();
        powerIcon.setActive(false);
        scoreBooster.setActive(false);
        x2Bounce.setActive(false);
      }
    });
    timeline.play();
  }

  activateArmor () {
    let g = this;
    soundManager.playSound('powerup-enabled');
    g.activePowerUp = config.ARMOR;
    g.player.turnOnArmor();
    let powerIcon = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'powerup-icons');
    powerIcon.setScale(0);
    powerIcon.setScrollFactor(0);
    powerIcon.setFrame('Armor.png');
    g.fg.push(powerIcon);
    let timeline = g.tweens.createTimeline();
    timeline.add({
      targets: powerIcon,
      scaleX: 0.5,
      scaleY: 0.5,
      // delay: 500,
      duration: 500,
      ease: 'Back.easeOut'
    });
    timeline.add({
      targets: powerIcon,
      scaleX: 0,
      scaleY: 0,
      duration: 250,
      delay: 500,
      ease: 'Back.easeIn',
      onComplete: () => {
        timeline.destroy();
        powerIcon.setActive(false);
        g.bile.start();
      }
    });
    timeline.play();
  }
  burstArmor () {
    let g = this;
    let powerIcon = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'powerup-icons');
    powerIcon.setScrollFactor(0);
    powerIcon.setScale(0.5);
    powerIcon.setFrame('Armor.png');
    g.fg.push(powerIcon);
    g.tweens.add({
      targets: powerIcon,
      alpha: 0,
      repeat: 5,
      duration: 100,
      repeatDelay: 100,
      onComplete: () => {
        powerIcon.setActive(false);
      }
    });
  }
  activateMagnet () {
    let g = this;
    soundManager.playSound('powerup-enabled');
    g.activePowerUp = config.MAGNET;
    g.player.turnOnMagnet();
    let powerIcon = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'powerup-icons');
    powerIcon.setScale(0);
    powerIcon.setScrollFactor(0);
    powerIcon.setFrame('Magnet.png');
    g.fg.push(powerIcon);
    let timeline = g.tweens.createTimeline();
    timeline.add({
      targets: powerIcon,
      scaleX: 0.5,
      scaleY: 0.5,
      // delay: 500,
      duration: 500,
      ease: 'Back.easeOut'
    });
    timeline.add({
      targets: powerIcon,
      scaleX: 0,
      scaleY: 0,
      duration: 250,
      delay: 500,
      ease: 'Back.easeIn',
      onComplete: () => {
        powerIcon.setActive(false);
        g.bile.start();
      }
    });
    timeline.add({
      targets: g.player.glowSprite,
      delay: config.POWER_UP_DURATION,
      alpha: 0,
      repeat: 10,
      duration: 100,
      repeatDelay: 100,
      onComplete: () => {
        g.startCoolDown();
        timeline.destroy();
        g.player.turnOffMagnet();
      }
    });
    timeline.play();
  }

  activateAntacid () {
    let g = this;
    soundManager.playSound('powerup-enabled');
    g.activePowerUp = config.ANTACID;
    g.bile.recede();
    let powerIcon = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'powerup-icons');
    powerIcon.setScale(0);
    powerIcon.setScrollFactor(0);
    powerIcon.setFrame('Antacid.png');
    g.fg.push(powerIcon);
    // let bubbles = g.add.sprite(config.CENTER_X, config.HEIGHT + 70, 'bubbles');
    let bubbles = g.add.sprite(config.CENTER_X, config.HEIGHT + 200, 'bubbles');
    bubbles.setOrigin(0.5, 1);
    bubbles.setScrollFactor(0);
    bubbles.play('bubbling');
    g.fg.push(bubbles);
    let timeline = g.tweens.createTimeline();
    timeline.add({
      targets: powerIcon,
      scaleX: 0.5,
      scaleY: 0.5,
      // delay: 500,
      duration: 500,
      ease: 'Back.easeOut'
    });
    timeline.add({
      targets: powerIcon,
      y: '+=' + config.HEIGHT,
      duration: 500,
      delay: 250,
      ease: 'Quad.easeIn'
    });
    timeline.add({
      targets: bubbles,
      y: config.HEIGHT + 70,
      duration: 1000,
      ease: 'Quad.easeOut'
    });
    timeline.add({
      targets: bubbles,
      delay: config.POWER_UP_DURATION,
      alpha: 0,
      repeat: 10,
      duration: 100,
      repeatDelay: 100,
      onComplete: () => {
        g.startCoolDown();
        timeline.destroy();
        powerIcon.setActive(false);
        bubbles.setActive(false);
        g.bile.start();
      }
    });
    timeline.play();
  }

  startCoolDown () {
    let g = this;
    g.activePowerUp = false;
    g.coolDownActive = true;
    // console.warn('!!! start cool down !!!');
    g.time.delayedCall(config.COOL_DOWN, () => {
      g.coolDownActive = false;
      // console.warn('!!! cool down complete !!!');
    });
  }

  update (time, delta) {

    let g = this;

    let accuracy = delta / FPS;

    // START STATS - for tracking game performance (Frames Per Second)
    if (g.sys.game.stats) {
      g.sys.game.stats.begin();
    }

    g.swipe.check();

    g.player.update();

    g.bile.update();

    g.levelManager.watch(g.player);

    let scroll = g.levelManager.getScroll();

    // g.bgDark.tilePositionY = scroll;
    // g.bg.tilePositionY = scroll;
    // console.log(scroll)

    scroll = scroll;
    g.bgDark.y = (scroll) - 1800;
    g.bg.y = (scroll) - 1800;
    g.bgDark2.y = (scroll);
    g.bg2.y = (scroll);
    g.bgDark3.y = (scroll) + 1800;
    g.bg3.y = (scroll) + 1800;

    let scoreValue = dataManager.getScore();
    if (g.scoreValue !== scoreValue) {
      g.scoreValue = scoreValue;
      g.sprites.score.setText(g.game.localisationManager.language != "ar" ? scoreValue.toLocaleString(g.game.localisationManager.language) : scoreValue);
    }

    _.each(g.fg, (sprite) => {
      if (sprite.anims && sprite.anims.currentAnim && sprite.anims.currentAnim.key === 'x2-bounce') {
        sprite.setX(config.CENTER_X - g.sprites.score.width / 2 - 25);
      }
    });

    // END STATS - for tracking game performance (Frames Per Second)
    if (g.sys.game.stats) {
      g.sys.game.stats.end();
    }
  }

  getBgColor () {
    let g = this;
    let key;
    if (g.getLastBg) {
      g.getLastBg = false;
      key = dataManager.getSessionItem('bgColor');
      if (key === undefined) {
        key = config.BG_COLORS[0];
        console.warn('getBgColor should not get this');
      }
      // console.log('getLastBg', key);
      return key;
    }
    if (g.bgColors === undefined || g.bgColors.length === 0) {
      g.bgColors = Phaser.Utils.Array.Shuffle(_.clone(config.BG_COLORS));
    }
    key = g.bgColors.pop();
    dataManager.setSessionItem('bgColor', key);
    // console.log('set bgColor', key);
    return key;
  }

  transitionBg () {
    let g = this;
    
    var color = g.getBgColor();

    g.tweens.add({
      targets: g.bg,
      alpha: 0,
      duration: config.TRANSITION_DURATION / 2,
      ease: 'Cubic.easeOut',
      onComplete: () => {
        g.bg.setTexture(color);
        g.tweens.add({
          targets: g.bg,
          alpha: 1,
          ease: 'Cubic.easeIn',
          duration: config.TRANSITION_DURATION / 2
        });
      }
    });
    
    g.tweens.add({
      targets: g.bg2,
      alpha: 0,
      duration: config.TRANSITION_DURATION / 2,
      ease: 'Cubic.easeOut',
      onComplete: () => {
        g.bg2.setTexture(color);
        g.tweens.add({
          targets: g.bg2,
          alpha: 1,
          ease: 'Cubic.easeIn',
          duration: config.TRANSITION_DURATION / 2
        });
      }
    });
    
    g.tweens.add({
      targets: g.bg3,
      alpha: 0,
      duration: config.TRANSITION_DURATION / 2,
      ease: 'Cubic.easeOut',
      onComplete: () => {
        g.bg3.setTexture(color);
        g.tweens.add({
          targets: g.bg3,
          alpha: 1,
          ease: 'Cubic.easeIn',
          duration: config.TRANSITION_DURATION / 2
        });
      }
    });
  }

  onSdkResume () {
    let g = this;
    // console.log('Play.onSdkResume');
    g.scene.launch('Settings');
  }

  showContinue () {
    let g = this;
    g.time.delayedCall(500, () => {
      g.bile.speed = 0;

      g.scene.launch('Score', { fadeBg: true });
    });
  }

  bringFgToTop () {
    let g = this;
    for (let i = g.fg.length - 1; i > -1; i--) {
      let sprite = g.fg[i];
      if (!sprite.active) {
        sprite.destroy();
        g.fg.splice(i, 1);
      }
    }
    _.each(g.fg, (sprite) => {
      g.children.bringToTop(sprite);
    });
  }
  
}

export default Play;
